import React, { useState, useEffect, useRef } from 'react';
import styles from './FeaturedOffers.module.css';
import { useNavigate } from 'react-router-dom';

const FeaturedOffersCarousel = ({ offers }) => {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState(null);
  const total = offers.length;
  const timeoutRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    if (total <= 1) return;
    timeoutRef.current = setTimeout(() => {
      setPrev(current);
      setCurrent(prevIdx => (prevIdx + 1) % total);
    }, 3000);
    return () => clearTimeout(timeoutRef.current);
  }, [current, total]);

  if (!offers || offers.length === 0) return null;

  const handleBuyNow = (offer) => {
    if (offer.slug) {
      navigate(`/product/${offer.slug}`);
    }
  };

  return (
    <div className={styles.carouselContainer}>
      <div className={styles.carouselTrack} style={{position: 'relative', minHeight: '340px'}}>
        {offers.map((offer, idx) => {
          // Slide activo y slide saliente
          let slideClass = styles.slide;
          if (idx === current) slideClass += ' ' + styles.slideActive;
          // El slide saliente se queda a la izquierda
          if (idx === prev) slideClass += ' ' + styles.slidePrev;
          return (
            <div
              key={offer.id || idx}
              className={slideClass}
              style={{ display: idx === current || idx === prev ? 'block' : 'none' }}
            >
              <div className={styles.offerBadge}>OFERTA</div>
              <img src={offer.image} alt={offer.title} className={styles.offerImage} />
              <div className={styles.offerContent}>
                <h3 >{offer.title}</h3>
                <div className={styles.priceContainer}>
                  <span className={styles.currentPrice}>Precio: ${offer.price}</span>
                  {offer.originalPrice && (
                    <span className={styles.originalPrice}>${offer.originalPrice}</span>
                  )}
                </div>
                <button className={styles.buyButton} onClick={() => handleBuyNow(offer)}>
                  Comprar ahora
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FeaturedOffersCarousel;
